import { where } from "firebase/firestore";
import { staffMapping } from "../../models/staffMapping";
import { FirestoreService } from "../firebase/firestoreService";

const COLLECTION_NAME = "staffUsernameMapping"

export const StaffMappingService = {
  async getStaffMapping(username: string): Promise<staffMapping | null> {
    try {
      const querySnapshot = await FirestoreService.queryCollection(COLLECTION_NAME, where("username", "==", username));
      if (querySnapshot.empty) {
        return null; // No profile found for the provided email
      }

      // Return the first matching user 
      let users: {
        [customerId: string]: staffMapping;
      } = {};
      return querySnapshot.docs[0].data() as staffMapping
    } catch (error) {
      console.error("Error fetching UID by email:", error);
      throw new Error("Failed to fetch UID. Please try again later.");
    }
  },
  async getStaffUnderOwner(email: string): Promise<{
    [customerId: string]: staffMapping;
  }> {
    try {
      const querySnapshot = await FirestoreService.queryCollection(COLLECTION_NAME, where("createdBy", "==", email));
      if (querySnapshot.empty) {
        return {}; // No profile found for the provided email
      }

      // Return the first matching user 
      let users: {
        [customerId: string]: staffMapping;
      } = {};
      querySnapshot.forEach((doc) => {
        if (doc.exists()) {
          const profile = (doc.data() as any) as staffMapping
          users[profile.userId] = profile;
        }
      });
      return users;
    } catch (error) {
      console.error("Error fetching UID by email:", error);
      throw new Error("Failed to fetch UID. Please try again later.");
    }
  }
}